import BaseApi from "./base";

class NotasProcesosApi extends BaseApi {
  constructor() {
    super("notas_procesos");
  }
}

export default new NotasProcesosApi();
